import brand from '@configs/brand'

// Wrapper de localStorage que aplica o prefixo da marca em todas as chaves.
// Os chamadores devem passar a chave SEM o prefixo da marca - o helper o
// adiciona automaticamente. Ex.: storage.get('UserData') -> "<prefix>.UserData".
const buildKey = (name) => `${brand.storagePrefix}.${name}`

export const storage = {
  get(name) {
    const raw = window.localStorage.getItem(buildKey(name))
    if (raw === null || raw === undefined) return undefined
    if (typeof raw === 'string') {
      try {
        return JSON.parse(raw)
      } catch (e) {
        return raw
      }
    }
    return raw
  },
  set(name, value) {
    window.localStorage.setItem(buildKey(name), JSON.stringify(value))
  },
  remove(name) {
    window.localStorage.removeItem(buildKey(name))
  },
  raw(name) {
    return window.localStorage.getItem(buildKey(name))
  },
  key(name) {
    return buildKey(name)
  }
}

// Mantém a assinatura legada storageItem('set'|'get'|'remove', name, value).
// O `name` deve ser passado SEM o prefixo da marca.
export const storageItem = (type, name, value) => {
  if (type === 'set') {
    storage.set(name, value)
    return undefined
  }
  if (type === 'get') return storage.get(name)
  if (type === 'remove') {
    storage.remove(name)
    return undefined
  }
  return undefined
}

export default storage
